export default function LoadingScreen({ fullscreen = true, label, video = true }) {
  return (
    <div data-testid="loading-screen" style={{ background: "#020202" }}
      className={`flex flex-col items-center justify-center ${fullscreen ? "min-h-screen" : "py-16 rounded-xl"}`}>
      {video ? (
        <video autoPlay muted loop playsInline poster="/athanor-logo.png" aria-label="Caricamento ATHANOR LAB"
          className={`${fullscreen ? "w-72 sm:w-96" : "w-48"} h-auto`}>
          <source src="/loader.webm" type="video/webm" />
          <source src="/loader.mp4" type="video/mp4" />
        </video>
      ) : (
        <img src="/athanor-logo.png" alt="ATHANOR LAB" data-testid="loading-logo"
          className={`${fullscreen ? "w-64 sm:w-80" : "w-40"} h-auto object-contain fade-up`} />
      )}
      {label && <div className="mt-2 text-xs text-[#C5A059]/80">{label}</div>}
    </div>
  );
}
